// HU-50-C7 · HU-24-C3/C5 · RNF-11: un reloj del plazo regulatorio, con TEXTO e ÍCONO y no solo
// color: rojo + «Plazo regulatorio vencido» + alerta; ámbar + «Vence mañana» + reloj.
//
// Vivía dentro de la bandeja regulatoria. CC-02 (B11, `ui/MG-ILE-1075.md`) pinta el MISMO reloj
// en la tarjeta de cada carta: se saca aquí para que la bandeja y la carta lean el estado con el
// mismo glosario (§8.1 R8) y no con dos mapas. El texto y la fecha los calcula el servidor con el
// calendario hábil del país (RN-20, RN-21); aquí no se recalcula nada.

import { AlertTriangle, CheckCircle2, Clock, FileCheck2, HelpCircle } from 'lucide-react';
import { Mono, StatusBadge } from './ui';
import type { Tono } from './ui';
import { comoFechaDeInstante } from '../lib/fechas';
import type { EstadoDelReloj, RelojDeBandeja } from '../api/regulatorio';

const RELOJ: Record<EstadoDelReloj, { tone: Tono; icon: typeof Clock }> = {
  vencido: { tone: 'danger', icon: AlertTriangle },
  por_vencer: { tone: 'warning', icon: Clock },
  en_plazo: { tone: 'success', icon: CheckCircle2 },
  cumplido: { tone: 'info', icon: FileCheck2 },
  sin_plazo_configurado: { tone: 'neutral', icon: HelpCircle },
};

/** Un reloj con su etiqueta: «Notificación: 09/09/2026» / «Informe final: 25/09/2026» (HU-24-C10). */
export default function RelojDelPlazo({ etiqueta, reloj, zonaHoraria, 'data-testid': testid }: {
  etiqueta: string; reloj: RelojDeBandeja;
  /** RN-82: la zona del país del caso (`useZonaDelPais`); `null` = Lima. */
  zonaHoraria: string | null;
  'data-testid'?: string;
}) {
  const { tone, icon } = RELOJ[reloj.estado] ?? RELOJ.sin_plazo_configurado;
  return (
    <span className="inline-flex flex-col gap-0.5" data-testid={testid}>
      <StatusBadge tone={tone} icon={icon}>{reloj.texto}</StatusBadge>
      <span className="text-meta text-ink-soft pl-1">
        {etiqueta}: {reloj.fecha_limite ? <Mono className="text-meta">{comoFechaDeInstante(reloj.fecha_limite, zonaHoraria)}</Mono> : 'sin fecha'}
      </span>
      {!reloj.calculo_fiable && (
        <span className="text-meta text-amber-700 pl-1">{reloj.advertencia ?? 'cálculo no fiable: falta el calendario'}</span>
      )}
    </span>
  );
}
